import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/user/list' // 광고목록 조회

const fetchKey = (page, maxData, status, searchWord, order) =>
	`${M_KEY}?${page && 'page=' + page}${maxData && '&maxData=' + maxData}${'&type=' + 'maker'}${status > 0 ? '&status=' + status : ''}${searchWord && '&searchWord=' + searchWord}${order && '&order=' + order}`;

export function useMakerUserList(page, maxData, status, searchWord, order) {
	// const { data: token } = useToken();

	const KEY = fetchKey(page, maxData, status, searchWord, order);


	const fetcher = () => fetchAPI(KEY);
	const { data, mutate, isLoading } = useSWR(`${KEY}`, fetcher, { revalidateOnFocus: true });

	return { makerUserList: data?.list, mutateMakerUserList: mutate, total: data?.total, isLoading };
}

async function fetchAPI(KEY:string): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, '', {});
		return {list: response.result?.result?.list || [], total: response.result?.result?.totalCount}
	} catch (error) {
		console.error('Failed to fetch Maker User List:', error);
		return { list: [], total: 0 };
	}
}